



























































































































































































import { Mixins, Component, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import { HubConnectionBuilder, LogLevel, HubConnection } from '@microsoft/signalr';

class WebsocketState {
  isDestroyed: boolean;
  isConnection: boolean;
  isUpdate: boolean;
  connection!: HubConnection;
  listSelectAcu!: I.AcuDataList[];
  constructor() {
    this.isDestroyed = false;
    this.isConnection = false;
    this.isUpdate = false;
  }

  Delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async Connect() {
    if (this.isDestroyed) return;
    const { hostname } = window.location;
    //const baseURL = process.env.NODE_ENV === 'development' ? `https://${hostname}:44393` : '';
    const baseURL = process.env.NODE_ENV === 'development' ? `https://localhost:44393` : '';
    console.log(baseURL);
    // 이미 연결이 열려 있는지 확인
    if (this.isConnection === true) {
      console.log('Connection is already open');
      return;
    }
    this.connection = new HubConnectionBuilder()
      .withUrl(baseURL + '/EventHub', {
        accessTokenFactory: () => 'test'
      })
      .configureLogging(LogLevel.Information)
      .build();
    this.connection
      .start()
      .then(() => {
        this.SetEvent();
        this.isConnection = true;
        console.log('SignalR 연결 성공');
      })
      .catch(async (err: Error) => {
        console.log('error~~~~');
        console.log(err);
        await this.Delay(2000);
        this.Connect();
      });
    console.log('connection');
  }

  SetEvent() {
    this.connection.on('AcuHealthInfo', (event: I.AcuDataList) => {
      this.listSelectAcu = this.listSelectAcu.map(acuid => {
        if (acuid.acuID === event.acuID) {
          return {
            ...acuid,
            ip: event.ip, // 변환된 IP 주소 문자열로 업데이트
            version: event.version, // 변환된 버전 문자열로 업데이트
            sync: event.sync, // 동기화 여부 업데이트
            connectState: event.connectState // 연결 상태 업데이트
          };
        }
        this.isUpdate = true;
        return acuid;
      });
    });
  }

  GetAcuHealthInfo() {
    if (this.isConnection === false) return;
    this.listSelectAcu.forEach(acu => {
      this.connection
        .invoke('GetAcuHealthInfo', acu.acuID)
        .then(() => {
          // 여기에 성공 시 실행할 코드를 작성하세요. 예: this.SetDoorStatus();
        })
        .catch((err: Error) => console.error(err.toString()));
    });
  }

  Destroy() {
    this.isDestroyed = true;
    this.connection.stop();
  }
}

class State {
  name: string;
  headers: unknown[];
  listAcu: I.AcuDataList[];
  listSelectAcu: I.AcuDataList[];

  constructor() {
    this.name = '';
    this.listAcu = [];
    this.listSelectAcu = [];
    this.headers = [
      { text: '아이디', value: 'acuID', align: 'start' },
      { text: '연결상태', value: 'connectState', align: 'start' },
      { text: '종류', value: 'deviceName', align: 'start' },
      { text: '이름', value: 'name', align: 'start' },
      { text: 'IP', value: 'ip', align: 'start' },
      { text: '버젼', value: 'version', align: 'start' },
      { text: '동기화여부', value: 'sync', align: 'start' }
    ];
  }
}

@Component
export default class AcuMonitor extends Mixins(AxPage) {
  state: State = new State();
  pageInfo: I.AcuHealthPageInfo | undefined;
  zoneCode = 0;
  websocketState!: WebsocketState;
  async prepare() {
    const baseData = await this.getBaseData();
    if (baseData) {
      this.pageInfo = baseData;
      // TODO: 이벤트 검색 구역 선택 State 저장
      this.zoneCode = this.getZoneList()[0]?.code || 0;
      this.state.listAcu = this.pageInfo.listAcu;
      this.ConnectWebSocket();
      this.change();
      // this.AcuInfo();
      // this.UpateInfo();
    }
  }

  async ConnectWebSocket() {
    this.websocketState = new WebsocketState();
    await this.$nextTick(() => {});
    this.websocketState.listSelectAcu = this.state.listSelectAcu;
    this.websocketState.Connect();
  }

  async getBaseData() {
    const result = await this.API.call.config.acuHealthPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async AcuInfo() {
    //초기화
    this.state.listAcu.forEach(item => {
      item.connectState = false;
    });
    this.websocketState.listSelectAcu = this.state.listAcu;
    setTimeout(() => {
      this.websocketState.GetAcuHealthInfo();
    }, 300);
  }

  async UpateInfo() {
    setInterval(() => {
      this.AcuInfoUpdate();
    }, 300);
  }

  async AcuInfoUpdate() {
    if (this.websocketState.isUpdate) {
      this.websocketState.isUpdate = false;
      this.state.listSelectAcu = this.websocketState.listSelectAcu;
    }
  }

  OnRefresh() {
    this.AcuInfo();
    this.UpateInfo();
  }

  change() {
    const list = this.state.listAcu.filter(x => x.zoneCode === this.zoneCode);
    this.state.listSelectAcu = list;
    //this.websocketState.listSelectAcu = this.state.listSelectAcu;
    this.OnRefresh();
  }
}
